// extracted by mini-css-extract-plugin
export default {"menuCol":"List_menuCol__czlEh","menuTitle":"List_menuTitle__x-i0U","menuItem":"List_menuItem__7d4t7","Link":"List_Link__bL5FQ"};